import React, { FC, useEffect, useState } from 'react'
import { useUserStore } from '../../../../store/useUserStore';
import GlobalFilterViewInput from './GlobalFilterViewInput';
import useUserByEmail from '../../../../store/ReactQueries/users/useUserByEmail';
import useGetAllUserGlobalFilters from '../../../../store/ReactQueries/globalFilters/useGetAllUserGlobalFilters';

export interface GlobalFiltersViewProps {
    email: string | undefined;
}

export const GlobalFiltersView: FC<GlobalFiltersViewProps> = ({ email }) => {

    const { user } = useUserStore();
    const userId = user?.userId ?? '';
    const { data: userByEmail } = useUserByEmail(email ?? '');
    const { data: globalFilters } = useGetAllUserGlobalFilters(userByEmail && userByEmail.id ? userByEmail.id : userId);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        setLoading(true);

        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className='grid-inputs-2'>
            {
                globalFilters?.map((globalFilter, index) =>
                    <GlobalFilterViewInput
                        key={index + globalFilter.fieldName}
                        globalFilter={globalFilter}
                        loading={loading}
                    />
                )}
        </div>
    );
}
export default GlobalFiltersView;